
import Vue from 'vue'
import CartPage from './CartPage.vue'

export default Vue.extend({
   name: 'StoreCartApp',
   components: {
      CartPage,
   },
   async mounted() {
      await this.$store.dispatch('loadModelData')
      await this.loadDefaultsFromQueryString()
   },
   methods: {
      async loadDefaultsFromQueryString() {
         if (this.$route.query.cartId) {
            const cartId = this.$route.query.cartId
            if (cartId && cartId.length > 12) {
               this.$store.dispatch('recoverCartItems', cartId)
            }
         }
      },
   },
})
